import React from 'react';

import {
  SecondaryTable,
  SecondaryTableHead,
  SecondaryTableBody,
  SecondaryTableRow,
} from '@Calix-Commerce/design-system/components';

const UnitsTable = ({ unitsData = [] }) => {
  return (
    <SecondaryTable style={{ marginTop: '1rem' }}>
      <SecondaryTableHead>
        <div>Serial Number</div>
        <div>FSAN Number</div>
        <div>MAC Address</div>
      </SecondaryTableHead>
      <SecondaryTableBody maxHeight="150px">
        {unitsData.map((unit) => (
          <SecondaryTableRow key={unit.serialNumber}>
            <div>{unit.serialNumber}</div>
            <div>{unit.fsan}</div>
            <div>{unit.macAddress}</div>
          </SecondaryTableRow>
        ))}
      </SecondaryTableBody>
    </SecondaryTable>
  );
};

export { UnitsTable };
